import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => (
  {
    icon: {
      fill: 'currentColor',
    },
    iconDisabled: {
      opacity: 0.2,
    },
  }
));

export default useStyles;
